<template>
 <div class="ui vertical segment">
    <app-header v-if="showMenu" ></app-header>
    <div class="ui container">
    <div v-bind:class="{'ui loading form': (loaded==1)}">
      <div id="demo" class="ui vertical stripe segment">
        <div id="content" class="ui basic segment">
          <h4 class="ui header">IPO Test</h4>
          <div class="two fields">
                <div class="ui left aligned nine wide column">
                    
                    <div class="ui labeled icon input">
                      <div class="ui label">Request Type </div>
                        <select class="ui input" style="width:350px"  v-model="requestSelected" >
                      <option v-for="type in requestTypes" v-bind:value="type.typeId" v-bind:key="type.typeId" >
                          {{ type.name }}
                      </option>
                    </select>&nbsp;&nbsp;&nbsp;&nbsp;
                     <button class="ui button primary" @click="setFilter">Search</button>
                    <button class="ui button" @click="resetFilter">Reset</button>
                    </div>
                    
                  </div>
              <br />
            </div>


              <div class="two fields">
                <div class="ui left aligned nine wide column">
                    
                    <div class="ui labeled icon input">
                      <div class="ui label">IPO Url &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                      <textarea disabled    style="width:350px" v-model = "this.ipo_url"></textarea>
                    </div>
                    
                  </div>
              <br />
            </div>


            <div class="two fields">
                <div class="field">
                    
                    Input Data 
                    <br />
                    <textarea   id="ipInputData" rows="10"  style="width:800px" ref="ipInputData" ></textarea>
                </div>
                <div class="field">
                    
                    Output  Data 
                    <br />
                    <textarea   id="ipOutputData" rows="10" cols="20" style="width:800px"  v-model= "this.output_data" ></textarea>
                </div>
            </div>
    
           
 
        </div><!-- content -->
      </div><!-- app -->
     </div><!-- vuetable-wrapper -->
    </div><!-- ui container -->
   
  </div>
</template>

<script>


import axios from 'axios'
import Vuetable from '@/components/vuetable-2/Vuetable.vue'
import VuetablePagination from '@/components/vuetable-2/VuetablePagination.vue'
import VuetablePaginationDropdown from '@/components/vuetable-2/VuetablePaginationDropdown.vue'
import VuetablePaginationInfo from '@/components/vuetable-2/VuetablePaginationInfo.vue'
import Vue from 'vue'
import Header from '@/components/Header.vue';



import Sahred from '@/components/shared/shared.js'

let E_SERVER_ERROR = 'Error communicating with the server'
var nextDay = new Date();
nextDay.setDate(nextDay.getDate()+1);

/* Detail Row  */
Vue.component('my-component', {
    template: '<div>A custom component!</div>'
})    







export default {
    components: {
    appHeader: Header
  
  },
  data () {
      return {
    input: {
        refreshtoken : ""
      }   ,
    diffMins : 0,
     loaded : "2",
    refreshToken_Event_Fired : 0 ,
    input_data : '',
    output_data : '',
    showMenu :true,
    tokenExpired : 0,
    ipo_url : '',
    httpOptions: {
      headers: {
      authorization: ""
      }
    },
    loading: '',
    searchFor: '',
    requestSelected : 1,
    requestTypes: [
    	{ typeId: 1, name: 'Request For Quote' },
      { typeId: 2, name: 'Purchase Order' }
    ]
   
  
 }
  },
  watch: {
    'perPage' (val, oldVal) {
      this.$nextTick(function() {
        this.$refs.vuetable.refresh()
      })
    },
    'paginationComponent' (val, oldVal) {
      this.$nextTick(function() {
        this.$refs.pagination.setPaginationData(this.$refs.vuetable.tablePagination)
      })
    }
  },
  created(){
    if(!localStorage.getItem('id_token')){
    this.$router.push({name: 'Login'});
    }else{
    this.checkTokenExpired();
    this.checkuserAccess = Sahred.checkuserAccess ;
    this.checkuserAccess();
    this.ipo_url = Vue.prototype.$ipohostname;
 
    }
  },
  methods: {
      getResponse(){
     
         if(localStorage.getItem('id_token')){
       this.loaded = 1; 
        this.input_data =  this.$refs.ipInputData.value.trim();
         this.input_data = this.input_data.replace(/\\/g, "")
       
       
          axios({ method: "POST", "url": Vue.prototype.$ipohostname +  "submitquote", 
                "data": {
                  xml_data : this.input_data
                
                }, 
                 "headers": 
                  { 
                    "content-type": "application/json" ,
                    "authorization": "bearer " + localStorage.getItem('id_token') 
                  }  }).then
                (
                  result => {
                      /*
                     this.output_data = result.data.xml_data
                     console.log('Response',this.output_data)
                     console.log('Response',result.data)*/
                      console.log('Response',result.data.xml_data)
                      this.output_data = result.data.xml_data
                    sweetAlert('Success!!!', '', 'success')
                     this.loaded = 2; 
                 }, 
                error => {
                console.error(error);
                sweetAlert('Something\'s Wrong!', error, 'error')
                 this.loaded = 2; 
                });
        } 
    },
    
  
   sessionExpired(errorStatus){
      if ((errorStatus === 403 || errorStatus === 401) && this.tokenExpired === 0 ) {
        this.tokenExpired = 1;
        alert('Session expired.Please login again!!')
        /* sweetAlert('Session expired!', 'Your user session is expired,please login again.', 'error')*/
        this.$router.push({name: 'Login'});
      }
   },
   



    checkTokenExpired(){
    if(this.refreshToken_Event_Fired == 0){
    this.getTokenExpiryTime();/* Get Token Expiry time  in Minutes */
    if(this.diffMins <= Vue.prototype.$session_Expire_in && this.diffMins > 0  ){ /* If Token Expiring in (expires_in from service) Mins,then get refereh token */
      this.refreshToken_Event_Fired = 1 ;
      this.getRefreshToken();
      this.refreshToken_Event_Fired = 0;
    }
     }
    },
    async getRefreshToken() {
    this.input['refreshtoken'] = localStorage.getItem('refresh_token')
    await axios({ method: "POST", "url": Vue.prototype.$appName + "token/refreshtoken", 
      "data": this.input, 
      "headers": { "Access-Control-Allow-Origin" : "*",
      "content-type": "application/json" } }).then
      (
          result => {
          this.response = result.data;
          localStorage.setItem('id_token', result.data.access_token);
          localStorage.setItem('refresh_token', result.data.refresh_token);

          var now = new Date();
          now.setMinutes(now.getMinutes() + Math.floor(result.data.expires_in / 60)  ); // timestamp
          now = new Date(now); // Date object
          localStorage.setItem('expiry_date', now);
         }, 
      error => {
          this.refreshToken_Event_Fired = 0;
          console.error(error);
      });

    },
    getTokenExpiryTime() {
      var expiry_date =  new Date(localStorage.getItem('expiry_date'));
      var today = new Date();
      var diffMs = (expiry_date - today); // milliseconds between now & logintime
      this.diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
       
    },

    
   
    
    showLoader () {
      this.loading = 'loading'
    },
    hideLoader () {
      this.loading = ''
    },
    allCap (value) {
      return value.toUpperCase()
    },
    
   
   
    setFilter () {
      this.getResponse();
    },
    resetFilter () {
      this.output_data = '';
       
    },
    preg_quote ( str ) {
       return (str+'').replace(/([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\|\:])/g, "\\$1");
    },
    highlight (needle, haystack) {
      return haystack.replace(
        new RegExp('(' + this.preg_quote(needle) + ')', 'ig'),
        '<span class="highlight">$1</span>'
      )
    },
    rowClassCB (data, index) {
      return (index % 2) === 0 ? 'odd' : 'even'
    },
    /*
     * Example of defining queryParams as a function
     */
    // queryParams (sortOrder, currentPage, perPage) {
    //   return {
    //     'sort': sortOrder[0].field + '|' + sortOrder[0].direction,
    //     'order': sortOrder[0].direction,
    //     'page': currentPage,
    //     'per_page': perPage
    //   }
    // },
     
   
    onLoadSuccess (response) {
     
      // set pagination data to pagination-info component
      this.$refs.paginationInfo.setPaginationData(response.data)

      let data = response.data.data
      if (this.searchFor !== '') {
        for (let n in data) {
          data[n].name = this.highlight(this.searchFor, data[n].name)
          data[n].email = this.highlight(this.searchFor, data[n].email)
        }
      }
    },
    onLoadError (response) {
      if (response.status == 400 &&  this.tokenExpired === 0) {
        sweetAlert('Something\'s Wrong!', response.data.message, 'error')
        his.$router.push({name: 'Login'});
      } else if (response.status == 403 || response.status == 401) {
        this.sessionExpired(response.status)
      }else {
       /* if(this.tokenExpired === 0){sweetAlert('Oops', E_SERVER_ERROR, 'error')*/
        this.$router.push({name: 'Login'});
       /* }*/
      }
    },
   
  
    
}

}
</script>
 <style type="text/css">
      .ui.vertical.stripe h3 {
        font-size: 2em;
      }
      .secondary.pointing.menu .toc.item {
        display: none;
      }
      .vuetable {
        margin-top: 1em !important;
      }
      .vuetable-wrapper.ui.basic.segment {
        padding: 0em;
      }
      .vuetable button.ui.button {
        padding: .5em .5em;
        font-weight: 400;
      }
      .vuetable button.ui.button i.icon {
        margin: 0;
      }
      .vuetable td i.handle-icon:hover {
        cursor: pointer;
      }
      .vuetable-actions {
        width: 15%;
        padding: 12px 0px;
        text-align: center;
      }
      .vuetable-pagination {
        background: #f9fafb !important;
      }
      .vuetable-pagination-info {
        margin-top: auto;
        margin-bottom: auto;
      }
      .highlight {
        background-color: yellow;
      }
      .vuetable-detail-row {
        height: 200px;
      }
      .detail-row {
        margin-left: 40px;
      }
      .expand-transition {
        transition: all .5s ease;
      }
      .expand-enter, .expand-leave {
        height: 0;
        opacity: 0;
      }
      tr.odd {
        background-color: #e6f5ff;
      }
      body {
        overflow-y: scroll;
      }
    </style>

 
 
    



// WEBPACK FOOTER //
// src/components/ipo/IPOTest.vue